import {AddressProofTemplate} from "./email-templates/AddressProofTemplate"
import {BlankTemplate} from "./email-templates/BlankTemplate"
import {KycIncompleteATemplate} from "./email-templates/KycIncompleteATemplate"
import {KycIncompleteBTemplate} from "./email-templates/KycIncompleteBTemplate"
import {KycIncompleteCTemplate} from "./email-templates/KycIncompleteCTemplate"
import {VerifiedWithNoOrderTemplate} from "./email-templates/VerifiedWithNoOrderTemplate"
import {VerifiedButNoOrderAfter2MonthsTemplate} from "./email-templates/VerifiedButNoOrderAfter2MonthsTemplate"
import {NewPersianUsersTemplate} from "./email-templates/NewPersianUsersTemplate"
import {MonthlyEmail} from "./email-templates/MonthlyEmail"

export const EmailTemplatesMixin = {
    data() {
        return {
            templates: [
                BlankTemplate,
                AddressProofTemplate,
                KycIncompleteATemplate,
                KycIncompleteBTemplate,
                KycIncompleteCTemplate,
                VerifiedWithNoOrderTemplate,
                VerifiedButNoOrderAfter2MonthsTemplate,
                NewPersianUsersTemplate,
                MonthlyEmail
            ],
        }
    },
}
